export default class IntegrationsUtils {
  static getProcessTypeKey (processType) {
    const processTypes = {
      consultaapi: 'keywords.api_query',
      jobenviadadosrest: 'keywords.send_data.rest',
      jobenviadadossoap: 'keywords.send_data.soap',
      resttosoap: 'keywords.rest_to_soap',
      workflow: 'keywords.workflow'
    }

    return processTypes[processType]
  }

  static getActiveIcon (active) {
    const icons = {
      true: 'mdi-check-circle-outline',
      false: 'mdi-close-circle-outline'
    }
    return icons[active]
  }

  static getActiveColor (active) {
    const colors = {
      true: 'primary',
      false: 'red'
    }
    return colors[active]
  }
}
